import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-44fd7ed2"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "overflow-hidden md:flex md:h-full" }
const _hoisted_2 = { class: "md:ml-4 p-3 md:flex-1" }
const _hoisted_3 = { class: "pt-2 sm:p-0 sm:m-0" }
const _hoisted_4 = { class: "pt-3 w-full md:w-100 lg:w-200" }
const _hoisted_5 = { class: "md:flex md:flex-row" }
const _hoisted_6 = { class: "flex flex-row md:flex-col flex-shrink-0 overflow-hidden account-menu" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "vr w-full" }, null, -1))
const _hoisted_8 = { class: "pt-5 tablet:pt-0 px-10 md:flex-grow" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_publicProfile = _resolveComponent("publicProfile")!
  const _component_personalInfo = _resolveComponent("personalInfo")!
  const _component_password = _resolveComponent("password")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("main", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("button", {
                class: _normalizeClass(["nav-link", `${ _ctx.tab == 'profile'?'active':'' }`]),
                onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.tab = 'profile'))
              }, "Public Profile", 2),
              _createElementVNode("button", {
                class: _normalizeClass(["nav-link", `${ _ctx.tab == 'personal'?'active':'' }`]),
                onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.tab = 'personal'))
              }, "Personal Information", 2),
              _createElementVNode("button", {
                class: _normalizeClass(["nav-link", `${ _ctx.tab == 'password'?'active':'' }`]),
                onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.tab = 'password'))
              }, "Change Password", 2)
            ]),
            _hoisted_7,
            _createElementVNode("div", _hoisted_8, [
              (_ctx.tab == 'profile')
                ? (_openBlock(), _createBlock(_component_publicProfile, { key: 0 }))
                : (_ctx.tab == 'personal')
                  ? (_openBlock(), _createBlock(_component_personalInfo, {
                      key: 1,
                      company: _ctx.company
                    }, null, 8, ["company"]))
                  : (_openBlock(), _createBlock(_component_password, {
                      key: 2,
                      company: _ctx.company
                    }, null, 8, ["company"]))
            ])
          ])
        ])
      ])
    ])
  ]))
}